import { EntityStore } from "./entityStore";
import { EntityCollection } from "./entityCollection";
import { ActivityService } from "./activityService";
import { UserService } from "./userService";
import { OrganizationService } from "./organizationService";
import { ApplicationService } from "./applicationService";
import { AttachmentService } from "./attachmentService";
import { FileStorageService } from "./fileStorageService";
import { IntegrationService } from "./integrationService";
import { NotificationService } from "./notificationService";
import { AlertService } from "./alertService";
import { RestClient } from "./restClient";
import { RealtimeClient } from "./RealtimeClient";
import { AuthService } from "./authService";
import { ExternalAuthProviderService } from "./externalAuthProviderService";
import { EventService } from "./eventService";
import { FeedService } from "./feedService";
import { RoleService } from "./roleService";
import { LogService } from "./logService";
import { GISService } from "./gis-service";
import { ListService } from "./listService";
import { ShapeService } from "./shapeService";
import { CameraService } from "./cameraService";
import { LradService } from "./lradService";
import { RuleService } from "./ruleService";
import { TimeConversion } from "./utils/timeConversion";
import { WorkstationInfo } from "./utils/workstationInfo";
import { ListCategoryService } from "./listCategoryService";
import { AssociationService } from "./associationService";
import { CameraGroupService } from "./cameraGroupService";
import { BerthService } from "./berthService";
import { SharingConnectionService } from "./sharingConnectionService";
import { SpotlightService } from "./spotlightService";
import { SystemHealthService } from "./systemHealthService";
import { FacilityService } from "./facilityService";
import { StatusBoardService } from "./statusBoardService";
import { LinkedEntitiesService } from "./linkedEntitiesService";
import { ReplayService } from "./replayService";
import { ChampService } from "./champService";
import { SystemNotificationService } from "./systemNotificationService";
import { TerminalService } from "./terminalService";
import { TranslationService } from "./translationService";
import { BaseMapsService } from "./baseMapsService";
import { DeviceService } from "./deviceService";
import { UnitService } from "./unitService";
import { BRCService } from "./brcService";
import { MapOverlayService } from "./mapOverlayService";
import { ReportService } from "./reportsService";
import { ChangeRequestService } from "./changeRequest";
import { EcoSettingsService } from "./ecoSettingService";
import { EventLookupsService } from "./eventLookupsService";
import { EntityIconsService } from "./entityIcons";
import { CameraClustersService } from "./cameraClustersService";
import { SmartCameraClustersService } from "./smartCameraClustersService";
import { DeviceTypeService } from "./deviceTypeService";
import { CompositeDeviceService } from "./compositeDeviceService";
import { DeviceGroupsService } from "./deviceGroupsService";
import { DeviceStateService } from "./deviceStateService";
import { PatrolTemplateService } from "./patrolTemplateService";
import { PatrolService } from "./patrolService";
import { DuressService } from "./duressService";
import { ReminderService } from "./reminderService";
import { EvacuationService } from "./evacuationService";
import { LPRService } from "./lprService";
import { ApprovalManagerService } from "./approvalManagerService";
import { AccessManagementService } from "./accessManagementService";

// --todo: name with "Service" on end

const entityStore = new EntityStore();
const entityCollection = new EntityCollection();
const activityService = new ActivityService();
const userService = new UserService();
const authService = new AuthService();
const externalAuthProviderService = new ExternalAuthProviderService();
const organizationService = new OrganizationService();
const applicationService = new ApplicationService();
const attachmentService = new AttachmentService();
const fileStorageService = new FileStorageService();
const integrationService = new IntegrationService();
const notificationService = new NotificationService();
const alertService = new AlertService();
const feedService = new FeedService();
const roleService = new RoleService();
const eventService = new EventService();
const logService = new LogService();
const restClient = new RestClient();
const realtimeClient = new RealtimeClient();
const gisService = new GISService();
const listService = new ListService();
const shapeService = new ShapeService();
const cameraService = new CameraService();
const lradService = new LradService();
const ruleService = new RuleService();
const timeConversion = new TimeConversion();
const workstationInfo = new WorkstationInfo();
const listCategoryService = new ListCategoryService();
const associationService = new AssociationService();
const cameraGroupService = new CameraGroupService();
const berthService = new BerthService();
const sharingConnectionService = new SharingConnectionService();
const spotlightService = new SpotlightService();
const systemHealthService = new SystemHealthService();
const facilityService = new FacilityService();
const statusBoardService = new StatusBoardService();
const linkedEntitiesService = new LinkedEntitiesService();
const replayService = new ReplayService();
const champService = new ChampService();
const systemNotificationService = new SystemNotificationService();
const terminalService = new TerminalService();
const translationService = new TranslationService();
const baseMapsService = new BaseMapsService();
const deviceService = new DeviceService();
const unitService = new UnitService();
const brcService = new BRCService();
const mapOverlayService = new MapOverlayService();
const reportsService = new ReportService();
const changeRequestService = new ChangeRequestService();
const ecoSettingService = new EcoSettingsService();
const eventLookupsService = new EventLookupsService();
const entityIconsService = new EntityIconsService();
const cameraClustersService = new CameraClustersService();
const smartCameraClustersService = new SmartCameraClustersService();
const deviceTypeService = new DeviceTypeService();
const compositeDeviceService = new CompositeDeviceService();
const deviceGroupsService = new DeviceGroupsService();
const deviceStateService = new DeviceStateService();
const patrolTemplateService = new PatrolTemplateService();
const patrolService = new PatrolService();
const duressService = new DuressService();
const reminderService = new ReminderService();
const evacuationService = new EvacuationService();
const lprService = new LPRService();
const approvalManagerService = new ApprovalManagerService();
const accessManagementService = new AccessManagementService();

export {
	entityStore,
	timeConversion,
	workstationInfo,
	entityCollection,
	activityService,
	userService,
	gisService,
	authService,
	externalAuthProviderService,
	organizationService,
	applicationService,
	fileStorageService,
	attachmentService,
	integrationService,
	notificationService,
	alertService,
	eventService,
	feedService,
	roleService,
	logService,
	restClient,
	realtimeClient,
	listService,
	listCategoryService,
	shapeService,
	cameraService,
	lradService,
	ruleService,
	associationService,
	cameraGroupService,
	berthService,
	sharingConnectionService,
	spotlightService,
	systemHealthService,
	facilityService,
	statusBoardService,
	linkedEntitiesService,
	replayService,
	champService,
	systemNotificationService,
	terminalService,
	translationService,
	baseMapsService,
	deviceService,
	unitService,
	brcService,
	mapOverlayService,
	reportsService,
	changeRequestService,
	ecoSettingService,
	eventLookupsService,
	entityIconsService,
	cameraClustersService,
	smartCameraClustersService,
	deviceTypeService,
	compositeDeviceService,
	deviceGroupsService,
	deviceStateService,
	patrolTemplateService,
	patrolService,
	duressService,
	reminderService,
	evacuationService,
	lprService,
	approvalManagerService,
	accessManagementService
};
